import ActionType from '@actions/type/login';

const loginDefaultState = {
  username: '',
  password: '',
  mempasswd: false,
  err: null,
  timestamp: -1,
  bid: '',
  bind: false,
  channel: null,
  innCount: null,
  localEmpty: true,
  remoteEmpty: true,
  userId: null,
  needVerify: false,
  yodaChecked: true,
  succMsg: '',
};

export function loginFormData(state = loginDefaultState, action) {
  switch (action.type) {
    case ActionType.LOGIN_SET_FORM_DATA:
      return {
        ...state,
        ...action.data,
      };
    case ActionType.LOGIN_SUCCESS:
      return {
        ...state,
        logon: true,
        ...action.data,
        timestamp: Date.now(),
      };
    case ActionType.LOGIN_FAIL:
      return {
        ...action.data,
        err: action.message,
        timestamp: Date.now(),
      };
    case ActionType.LOGIN_HIDE_ERROR:
      return {
        ...state,
        err: null,
        timestamp: -1,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/login/index.js